import * as React from "react";

const DoneIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g
      stroke="#00A861"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_790_2829)"
    >
      <path d="M8.25 12.75 10.5 15l5.25-5.25"></path>
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
    </g>
    <defs>
      <clipPath id="clip0_790_2829">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default DoneIcon;
